export interface FaqEntry {
  question: string;
  answer: string;
}

export const FAQS: FaqEntry[] = [
  {
    question: 'What is a 3.5 NTRP player?',
    answer:
      'A 3.5 NTRP is solid recreational tennis tipping into competitive play. A 3.5 hits dependable groundstrokes with some pace and spin, has a working second serve, plays smart doubles, and can construct a point. In UTR a 3.5 NTRP male player typically lands around UTR 5–6; women’s 3.5 NTRP lands closer to UTR 4–5. In WTN it’s around 17.',
  },
  {
    question: 'How does UTR compare to NTRP?',
    answer:
      'UTR is algorithmic and globally normalized — every match counts and your rating tightens as you play. NTRP is USTA-specific, capped at 7.0, and rated in 0.5 steps for league brackets. Below NTRP 3.5, UTR scales steeply (3.0 NTRP ≈ UTR 3–4). At NTRP 4.0 and above, every 0.5 NTRP step is roughly +2 UTR. Our converter applies a banded model based on the in-product conversion we use across Bounce.',
  },
  {
    question: 'What is WTN (World Tennis Number)?',
    answer:
      'WTN is the ITF’s official global rating launched in 2022 to unify federation ratings worldwide. It runs from 40 (just learning) down to 1 (top pros) — lower is stronger. National federations in 100+ countries feed match results into it, so it’s the closest thing tennis has to a truly global rating. WTN ~17 ≈ NTRP 3.5 ≈ UTR 5.',
  },
  {
    question: 'What about ITN? Did WTN replace it?',
    answer:
      'Yes. ITN (ITF Tennis Number) was the previous global rating, running 10.3 (beginner) to 1 (world-class) in 0.5 steps. It was effectively replaced by WTN in 2022. If you have an old ITN from a federation profile, you can use it as a starting point in this converter, but new ITF-aligned ratings now publish as WTN.',
  },
  {
    question: 'NTRP vs. Dynamic NTRP — what’s the difference?',
    answer:
      'NTRP is the 0.5-step band your USTA league plays in (e.g., 3.5 or 4.0). Dynamic NTRP is the underlying 3-decimal computer rating that USTA actually computes from your league match results. It moves continuously and decides whether you bump up or down at year-end. Both use the 1.0–7.0 scale.',
  },
  {
    question: 'Why does my UTR differ from my NTRP?',
    answer:
      'They measure overlapping but distinct things. UTR weighs every recorded match (including non-USTA events, college matches, and international play) and rewards close losses to higher-rated players. NTRP only uses USTA-sanctioned league/tournament results and rounds into half-step bands. Tournament-active players often see UTR move faster than NTRP.',
  },
  {
    question: 'Does the converter account for gender for NTRP?',
    answer:
      'Yes. Women’s NTRP maps about half a level lower in UTR than men’s NTRP at the same number (a women’s 4.0 NTRP is typically a slightly lower UTR than a men’s 4.0). We apply that adjustment when you pick a division. This mirrors the conversion we use across Bounce for cross-system normalization.',
  },
  {
    question: 'How accurate are these conversions?',
    answer:
      'Conversions are approximations — no organization publishes an official cross-system table. UTR ↔ Dynamic NTRP is the tightest at the upper end because both are algorithmic. UTR ↔ self-rated NTRP and UTR ↔ ITN are the loosest because those systems use coarse 0.5-step bands. Treat any cross-system value as an estimate with a confidence range, and trust the rating from the system that has the most data on you.',
  },
  {
    question: 'How do I get a UTR rating?',
    answer:
      'Sign up at utrsports.net (free) and log matches via verified events or your own match recording. As you play, UTR converges toward your true level. Most USTA tournaments, ITA college events, and ITF junior events feed UTR automatically. Your profile shows a reliability score that grows with verified matches.',
  },
  {
    question: 'How do I get an NTRP rating?',
    answer:
      'Either self-rate against USTA’s 1.0–7.0 guidelines when you create a USTA account, or play USTA league matches and you’ll receive a year-end computed NTRP rating in November based on dynamic NTRP movement.',
  },
  {
    question: 'How often do these ratings update?',
    answer:
      'UTR can update after every logged match. WTN updates as federation match results post (typically weekly). Dynamic NTRP updates throughout the USTA league season. NTRP year-end ratings publish each November. ITN is effectively frozen now that WTN has replaced it. Self-rated only changes when you decide to update.',
  },
  {
    question: 'What rating do I need to play in a college tennis match?',
    answer:
      'College tennis uses UTR as the primary benchmark. NCAA Division I men typically recruit at UTR 11+, women UTR 9+. Division II/III recruit roughly two UTR points lower. NAIA/junior college overlaps the lower band. Most college coaches will ask for your UTR before NTRP.',
  },
  {
    question: 'Is there an official conversion between these systems?',
    answer:
      'No rating organization publishes an official cross-system conversion table. Our converter combines published guidance, the in-product conversion model we use across Bounce, and statistical correlation across multi-rated players. Treat any cross-system value as an estimate, with a confidence range.',
  },
];
